import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import Dashboard from './../components/Menu/Dashboard'
import PropTypes from 'prop-types';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

class HomeContainer extends Component {
    
    
    handleOnClick = () => {
        this.props.history.push('/customers')
    }

    renderAllBody = (renderBody, renderInfoBody, renderChart) => {
        return  <Grid container spacing={3}>
                    <Grid item xs={12} sm = {12} md={12} lg = {12} xl={12}>
                        {renderBody}
                    </Grid>
                    <Grid item xs={12} sm = {12} md={6} lg = {6} xl={6}>
                        { (isMobile) ? renderChart : renderInfoBody}
                    </Grid>
                    <Grid item xs={12} sm = {12} md={6} lg = {6} xl={6}>
                        { (isMobile) ? renderInfoBody : renderChart}
                    </Grid>
                </Grid>
    }
    
    render() {
        const {renderBody, renderInfoBody, renderChart, loading} = this.props
        return (
            <div >
                <Dashboard
                    title= "Dashboard"
                    body = { this.renderAllBody(renderBody, renderInfoBody, renderChart) }
                    multiple = {false}
                />
                <LoadingScreen open = { !loading } />
            </div>
        );
    }
}

HomeContainer.propTypes = {
    user: PropTypes.object,
}

export default withRouter(HomeContainer);